import { useEffect, useState } from "react";
import API from "../lib/TimeEditAPI";
import { mapResults } from "../components/preferences/PrefsCoreAPI.utils";
import { TExtIdKind } from "../components/activityinfo/ActivityInfo.utils";

type TExtIdNames = Record<"objects" | "fields" | "types", Record<string, { label: string }>>;

const kindToKey = { object: "objects", field: "fields", type: "types" } as const;

/**
 * Looks up the names of TE objects, fields and types by ext id
 */
export const useExtIdNames = (extIds: Record<TExtIdKind, string[]>) => {
    const [names, setNames] = useState<TExtIdNames>({ objects: {}, fields: {}, types: {} });
    const key = JSON.stringify(extIds);

    useEffect(() => {
        let cancelled = false;
        API.getObjectNamesByExtid(extIds.object, false, (objects) => {
            API.getTypesByExtid(extIds.type, true, (types) => {
                API.getFieldsByExtid(extIds.field, (fields) => {
                    if (!cancelled) {
                        setNames(mapResults(objects, types, fields));
                    }
                });
            });
        });
        return () => {
            cancelled = true;
        };
        // Keyed on the ext ids' contents, since the object is new on every render.
    }, [key]);

    return (extId: string, kind: TExtIdKind): string =>
        names[kindToKey[kind]][extId]?.label || extId;
};
